import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreditorLoginComponent } from './pages/creditor-login/creditor-login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ResolveGuard } from './core/guard/resolve.guard';
import { PodFormCourtComponent } from './pages/pod-form-court/pod-form-court.component';
import { RegistrationFormPrintComponent } from './shared/components/account-request-and-pod-submission/preview-and-declare/registration-form-print/registration-form-print.component';
import { UserProfileComponent } from './pages/creditor-home/user-profile/user-profile.component';
import { UserAccountManagementComponent } from './pages/user-account-management/user-account-management.component';
import { ContactUsMessageComponent } from 'src/app/pages/contact-us/contact-us-message/contact-us-message.component';
import { TermsAndConditionsComponent } from 'src/app/pages/terms-and-conditions/terms-and-conditions.component';
import { BroadcastDetailsComponent } from './pages/creditor-home/broadcast-details/broadcast-details.component';
import { PrivilegeGuard } from 'src/app/core/guard/privilege.guard';
import { AuthenticationGuard } from './core/guard/authentication.guard';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { SupportingDocumentClaimsComponent } from './shared/components/supporting-document-claims/supporting-document-claims.component';
import { SupportingDocumentsClaimDetailComponent } from './shared/components/supporting-documents-claim-detail/supporting-documents-claim-detail.component';
import { FaqComponent } from './pages/creditor-home/faq/faq.component';
import { AdjudicationProxyFormPopupComponent } from './pages/creditor-claimant/adjudication-proxyform-popup/adjudication-proxyform-popup.component';
import { AdjudicationProxyFormScreenComponent } from './pages/creditor-claimant/adjudication-proxyform-screen/adjudication-proxyform-screen.component';


const routes: Routes = [
  {
    path: '',
    component: CreditorLoginComponent,
    resolve: {
      labelCaptionData: ResolveGuard,  
    },
  },
  {
    path: 'login',
    component:ContactUsMessageComponent,
    canActivate: [AuthenticationGuard],
    resolve: {
      labelCaptionData: ResolveGuard,
    },

  },
  {
    path:'contact-us-message',
    
    component:ContactUsMessageComponent
  },
  {
    path:'terms-and-conditions',
    
    component:TermsAndConditionsComponent
  },
  {
    path:'about-us',
    component:AboutUsComponent,
    resolve:{
      labelCaptionData: ResolveGuard
    }
  },
  {
    path: 'user-profile',
    component: UserProfileComponent,
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
  {
    path: 'adjudication-proxyform-screen',
    component: AdjudicationProxyFormScreenComponent,
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
  {
    path: 'adjudication-proxyform-popup',
    component: AdjudicationProxyFormPopupComponent,
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
{
    path: 'Claimant',  
    loadChildren: () =>
      import(
        './pages/account-request-and-pod-submission/claimant/claimant.module'
      ).then((mod) => mod.ClaimantModule),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
  {
    path: 'CompanyOrIndividual',
    loadChildren: () =>
      import(
        './pages/account-request-and-pod-submission/company-or-individual/company-or-individual.module'
      ).then((mod) => mod.CompanyOrIndividualModule),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
  {
    path: 'RegistrationGuideline',
    loadChildren: () =>
      import('./pages/registraion-guideline/registraion-guideline.module').then(
        (mod) => mod.RegistraionGuidelineModule
      ),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
  {
    path: 'RegistrationFilling',
    loadChildren: () =>
      import('./pages/registration-filling/registration-filling.module').then(
        (mod) => mod.RegistrationFillingModule
      ),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
  {
    path: 'UenView',
    loadChildren: () =>
      import('./pages/uen-view/uen-view.module').then(
        (mod) => mod.UenViewModule
      ),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
 
  {
    path: 'appendixA',
    loadChildren: () =>
      import('./pages/appendix/appendix.module').then(
        (mod) => mod.AppendixModule
      ),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
  {
    path: 'AddSecurity',
    loadChildren: () =>
      import('./pages/add-security/add-security.module').then(
        (mod) => mod.AddSecuritydModule
      ),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
 
  {
    path: 'PreviewAndDeclare',
    loadChildren: () =>
      import('./pages/pod-form-court/pod-form-court.module').then(
        (mod) => mod.PodFormCourtModule
      ),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
  
  {
    path: 'creditor-claimant',
    loadChildren: () =>
      import('./pages/creditor-claimant/creditor-claimant.module').then(
        (mod) => mod.CreditorClaimantModule
      ),
      resolve: {
        labelCaptionData: ResolveGuard,privilege:PrivilegeGuard
      },
  },

  {
    path: 'creditorhome',
    loadChildren: () =>
      import('./pages/creditor-home/creditor-home.module').then(
        (mod) => mod.CreditorHomeModule
      ),
    canActivate: [AuthenticationGuard],
    resolve: {
      labelCaptionData: ResolveGuard,
    },
  },
 
  {
    path: 'contact',
    loadChildren: () =>
      import('./pages/contact-us/contact-us.module').then(
        (mod) => mod.ContactUsModule
      ),
  },
  {
    path: 'user-account-details',
    loadChildren: () =>
      import('./pages/user-account-management/user-account-management.module').then(
        (mod) => mod.UserAccountManagementModule
      ),
    resolve: {
      labelCaptionData: ResolveGuard,
    },
    
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./pages/contact-us/contact-us-routing.module').then(
        (mod) => mod.ContactUsRoutingModule
      ),
  },
  {
    path: 'broadcast-details',
    canActivate: [AuthenticationGuard],
    component: BroadcastDetailsComponent
  },
  { path: 'registration-print', component: RegistrationFormPrintComponent
  },
  { path: 'faq', component: FaqComponent,
    // resolve: {
    // labelCaptionData: ResolveGuard,
    // },
  },
  {
    path:'supporting-documents-claim-detail',
    canActivate: [AuthenticationGuard],
    component:SupportingDocumentsClaimDetailComponent
    ,
    resolve: {
      labelCaptionData: ResolveGuard,
    }
  },
  { path: '**', 
  redirectTo: ''
},


    
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
